import { Popup } from 'antd-mobile'
import React from 'react'
import '../styles/ExerciseCard.css'
import '../styles/EditRecommendationModal.css'

function ExerciseSummaryModal({ visible, onClose, summary }) {
  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      onClose={onClose}
      position="bottom"
      bodyClassName="modal-popup"
    >
      <div className="modal-content">
        <div className="modal-header-wrapper">
          <div className="modal-header" style={{ padding: '5px 0px 2px 0px', marginBottom: '26px' }}>
            <h2>Key Observations</h2>
            <button
              onClick={onClose}
              className="modal-close-btn"
              aria-label="Close"
            >
              Close
            </button>
          </div>
        </div>
        <div className="exercise-container" style={{
            background: '#ffffff',
            borderRadius: '8px',
            padding: '16px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}>
          <p className="observations-text">{summary || 'No observations available.'}</p>
        </div>
      </div>
    </Popup>
  )
}

export default ExerciseSummaryModal
